export const EyeMark = ({ className = "w-8 h-8" }) => (
  <svg
    viewBox="0 0 100 100"
    className={`${className} text-[#D4AF37]`}
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    aria-hidden="true"
  >
    <circle cx="50" cy="50" r="45" strokeOpacity="0.3" strokeDasharray="4 4" />
    <circle cx="50" cy="50" r="34" strokeOpacity="0.6" />
    <circle cx="50" cy="50" r="22" strokeOpacity="0.9" />
    <path d="M20 50 Q50 20 80 50 Q50 80 20 50 Z" fill="rgba(212,175,55,0.1)" />
    <circle cx="50" cy="50" r="7" fill="currentColor" stroke="none" />
  </svg>
);

export const Logo = () => (
  <a href="/" className="flex items-center gap-3 group" data-testid="header-logo">
    <EyeMark className="w-9 h-9 transition-transform duration-700 group-hover:rotate-180" />
    <div className="leading-tight">
      <span className="font-display text-sm font-bold tracking-[0.2em] text-[#F8FAFC] block">
        THE END OF THE OBVIOUS
      </span>
      <span className="font-mono-alt text-[10px] uppercase tracking-[0.3em] text-[#D4AF37]/70">
        Gg Elves Archive
      </span>
    </div>
  </a>
);
